import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1703f6da&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=1703f6da&prod&lang=scss&scoped=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=1703f6da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703f6da",
  null
  
)

export default component.exports